import { Route } from '@/router/types'

export const expressRoutes: Route[] = [
  {
    path: '/admin/express_config',
    name: '#adminExpressConfig',
    component: () =>
      import('@/pages/Admin/ExpressConfig/PracticeSummary/PracticeSummary.vue'),
    meta: {
      title: 'Express Config',
      permissionCheck: 'canEditEmrExpressConfig',
    },
  },
  {
    path: '/admin/express_config/practices/:practiceId',
    name: '#expressPracticeDetails',
    component: () =>
      import('@/pages/Admin/ExpressConfig/PracticeDetails/PracticeDetails.vue'),
    props: true,
    meta: {
      title: 'Practice Details',
      permissionCheck: 'canEditEmrExpressConfig',
    },
  },
  {
    path: '/admin/express_config/map_practices_reports/:mapPracticeReportId',
    name: '#expressMapPracticeReportsDetails',
    component: () =>
      import('@/pages/Admin/ExpressConfig/ReportDetails/ReportDetails.vue'),
    props: true,
    meta: {
      title: 'Report Details',
      permissionCheck: 'canEditEmrExpressConfig',
    },
  },
]
